// import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ToolboxDetailHeader from "../ToolboxDetailHeader";

import Box from "@mui/material/Box";
// import PreferencesButtons from "./components/PreferencesButtons";

const ToolManagement = () => {
   const { t } = useTranslation("flowDesigner");
   return (
      <Box py={2} pl={1} pr={1} sx={{ flexGrow: 1 }}>
         <ToolboxDetailHeader title={t("toolbox.headers.tool_management")} />
         <Box pr={2} sx={{ overflow: "hidden", overflowY: "auto", height: "auto", scrollbarWidth: "thin" }}></Box>
      </Box>
   );
};

export default ToolManagement;
